var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SelectTableDialog',{attrs:{"title":this.$t('supplierDeliveryOrder.creatDialog.title.create'),"searchColumns":_vm.searchColumns,"columnList":_vm.columnList,"defaultVisible":_vm.defaultVisible,"API":_vm.listOrderAPI,"extraData":{
    contractCategory: 'purchase',
    contractStatus: 'ZT03',
    deliveryFlag: '1', //限制类型
    deliverableQuantityStart: 0, // 测试 后端叫加上这个参数
    departmentCode: _vm.userInfo.departmentCode,
    companyCode: _vm.userInfo.companyCode,
  },"propCode":"contractNo","width":"80%"},on:{"close":_vm.close,"dblclickEvent":_vm.dblclickEvent,"confirm":_vm.confirm,"changeQuery":_vm.changeQuery}})
}
var staticRenderFns = []

export { render, staticRenderFns }